import Reveal from "../Reveal";

const stories = [
  "The customer success that never becomes a case study.",
  "The team achievement nobody celebrates.",
  "The innovation hidden inside day-to-day operations.",
  "The impact people experience but nobody captures.",
];

export default function Insight() {
  return (
    <section
      id="insight"
      data-testid="insight-section"
      className="py-24 md:py-36 border-t border-[#E2DCD0] bg-[#F2EFEB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <Reveal className="lg:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#C86A53] mb-8">
              02 — The Insight
            </p>
            <h2
              data-testid="insight-headline"
              className="font-display font-light tracking-tighter leading-[0.95] text-[#0F172A] text-5xl md:text-6xl lg:text-7xl"
            >
              Every business <br /> has <span className="italic">stories.</span>
            </h2>
            <p className="font-display italic text-3xl md:text-4xl text-[#475569] mt-6 leading-snug">
              Most simply aren't telling them.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="overflow-hidden aspect-[4/5] border border-[#E2DCD0]">
              <img
                src="https://plus.unsplash.com/premium_photo-1726866086064-92a334e2a26c?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0"
                alt="A group of older friends laughing together on a sofa — the kind of moment that becomes a story"
                className="w-full h-full object-cover object-left transition-transform duration-[2000ms] hover:scale-105"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>

        {/* Story list as editorial bento */}
        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-2 border-t border-l border-[#E2DCD0]">
          {stories.map((s, idx) => (
            <Reveal key={idx} delay={idx * 0.08}>
              <div
                data-testid={`insight-story-${idx}`}
                className="border-r border-b border-[#E2DCD0] p-8 md:p-12 group hover:bg-[#F9F6F0] transition-colors duration-500"
              >
                <span className="font-display text-5xl text-[#C86A53] block mb-4 leading-none">
                  0{idx + 1}
                </span>
                <p className="font-display text-2xl md:text-3xl leading-snug text-[#0F172A] font-light">
                  {s}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-16 md:mt-24 max-w-3xl">
          <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-start">
            <p className="font-display italic text-2xl md:text-3xl text-[#0F172A] leading-snug">
              Stories help people understand what makes your organisation different.
            </p>
            <p className="text-lg text-[#475569] font-light leading-relaxed pt-2 md:pt-4 md:border-l md:border-[#E2DCD0] md:pl-8">
              And understanding creates trust. The kind of trust that turns
              casual readers into loyal customers, sceptics into advocates,
              and teams into believers.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
